import { useChatStore } from '@/store/chatStore';
import { BotImageSeriesMessage } from '@/types';
import { motion } from 'framer-motion';
// @ts-ignore
import 'swiper/css';
// @ts-ignore
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SliderArrows, useSliderArrows } from './shared/SliderArrows';

type MessageImagesSeriesProps = {
  message: BotImageSeriesMessage;
  messageId: string;
};

const MessageImagesSeries = ({ message, messageId }: MessageImagesSeriesProps) => {
  const { setFullScreenImage } = useChatStore();
  const {
    prevButtonRef,
    nextButtonRef,
    isBeginning,
    isEnd,
    navigation,
    onSwiper,
    onSlideChange,
    onBeforeInit,
  } = useSliderArrows();

  const handleClick = (key: string, image: string) => {
    setFullScreenImage({ key, image });
  };

  const slidesPerView = message?.content?.length < 2 ? 1 : message?.content?.length < 4 ? 2 : 3;

  return (
    <div className="group relative mx-[-20px] flex max-w-[calc(100%+40px)] flex-col overflow-visible">
      <Swiper
        className="w-full !overflow-visible !px-[20px] [&>.swiper-wrapper]:!overflow-visible"
        slidesPerView={slidesPerView}
        spaceBetween={8}
        modules={[Navigation]}
        navigation={navigation}
        onSwiper={onSwiper}
        onSlideChange={onSlideChange}
        onBeforeInit={onBeforeInit}
      >
        {message?.content?.map((image, index) => (
          <SwiperSlide key={`${messageId}-${index}`}>
            <motion.div
              layoutId={`${messageId}-${index}`}
              onClick={() => handleClick(`${messageId}-${index}`, image)}
              className="aspect-square w-full cursor-zoom-in overflow-hidden rounded-lg"
            >
              <img src={image} alt="image" className="h-full w-full object-cover" />
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
      <SliderArrows
        prevButtonRef={prevButtonRef}
        nextButtonRef={nextButtonRef}
        isBeginning={isBeginning}
        isEnd={isEnd}
      />
    </div>
  );
};

export default MessageImagesSeries;
